/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ReAssignUsersTeamRequest model module.
 * @module model/ReAssignUsersTeamRequest
 * @version V1
 */
class ReAssignUsersTeamRequest {
    /**
     * Constructs a new <code>ReAssignUsersTeamRequest</code>.
     * @alias module:model/ReAssignUsersTeamRequest
     */
    constructor() { 
        
        ReAssignUsersTeamRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ReAssignUsersTeamRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ReAssignUsersTeamRequest} obj Optional instance to populate.
     * @return {module:model/ReAssignUsersTeamRequest} The populated <code>ReAssignUsersTeamRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReAssignUsersTeamRequest();

            if (data.hasOwnProperty('oldTeamId')) {
                obj['oldTeamId'] = ApiClient.convertToType(data['oldTeamId'], 'Number');
            }
            if (data.hasOwnProperty('newTeamId')) {
                obj['newTeamId'] = ApiClient.convertToType(data['newTeamId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ReAssignUsersTeamRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReAssignUsersTeamRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} oldTeamId
 */
ReAssignUsersTeamRequest.prototype['oldTeamId'] = undefined;

/**
 * @member {Number} newTeamId
 */
ReAssignUsersTeamRequest.prototype['newTeamId'] = undefined;






export default ReAssignUsersTeamRequest;

